<template>
  <div :class="['landing']">
    <div class="landing-nav__logo sticky mobile-no-sticky">
      <img src="/figures/usb-club-wordmark.svg" />
    </div>
    <!-- <div class="landing-nav">
      <div class="landing-nav-items">
        <a href="https://www.instagram.com/bringyourusb" target="_blank">IG</a>
        <a href="https://are.na/teal/usb-club" target="_blank" style="font-size: 1.9rem; margin-top: 3px">**</a>
        <a href="https://twitter.com/usbclub" target="_blank">Twitter</a>
        <a href="/careering">Careering</a>
      </div>
    </div> -->

    <!-- Header -->
    <div class="grid">
      <div class="column-full column-center" ref="hero">
        <!-- <LogoHero /> -->
        <video autoplay loop muted playsinline class="logo-video hero-hide-1" ref="heroLogo">
          <source src="/figures/collage/c-logo-header__4444-0a-hvec.mov" type="video/quicktime" />
          <source src="/figures/collage/c-logo-header-0h.webm" type="video/webm" />
        </video>
        <h1 class="hero-hide-2">A social file exchange.</h1>
        <p class="subtitle centered hero hero-hide-3">For designers, artists, DJs, writers, musicians, <span
            class="mobile-hide"><br /></span>researchers, engineers.</p>
      </div>
    </div>
    <div class="main-sticky sticky" ref="mainCta">
      <a href="/classic" @click.prevent="transitionTo('/classic')" class="cta hero-hide-4">Buy a USB<span
          class="cta-arrow"><img class="arrow-right" src="/figures/arrow-right-small.svg" /><img
            class="arrow-right lightup" src="/figures/arrow-right-small.svg" /></span></a>
    </div>

    <div class="spacer-medium"></div>

    <!-- Media collage -->
    <div class="grid grid-wide">
      <div class="column-full column-center">
        <div class="transport-banner" @click="transitionTo('/transport')" @mouseover="hoverTransportBanner"
          @mouseleave="unhoverTransportBanner">
          <div class="transport-banner-inner">
            <img src="/figures/Transport CTA Banner.png" />
            <div class="transport-banner-shadow"></div>
            <div class="transport-banner-text-container">
              <!-- <h3>Now Available</h3> -->
              <h2>Transport</h2>
              <h2 class="h2-subtitle">Discover your next drive <span class="arrow-right" ref="transportBannerArrow"><img
                    src="/figures/arrow-right-medium.svg" /></span></h2>
            </div>
          </div>
        </div>
        <div class="folder-top">
          <img src="/figures/folder-top.png" />
        </div>
        <div class="folder-bottom">
          <div class="folder-bottom__bg"></div>
          <div class="spacer-1"></div>
          <h2>What can I share?</h2>
          <p class="subtitle centered">USB Club is file-type agnostic so you can share <span
              class="mobile-hide"><br /></span>and preserve all forms of creativity.</p>
          <div class="spacer-2"></div>
          <div class="filetypes">
            <div class="chip" v-for="chip in chips" :key="chip">{{ chip }}</div>
          </div>

          <div class="spacer-4"></div>

          <MediaCollage />

          <div class="spacer-4"></div>
        </div>
      </div>
    </div>

    <div class="spacer-medium"></div>


    <!-- How join -->
    <!-- 
    <div class="grid">
      <div class="column-three">
        <h2>How do I join?</h2>
        <p class="subtitle">We're currently accepting new members on a rolling basis.</p>
      </div>
      <div class="column-five">
        <JoinSteps />
      </div>
    </div>
  -->

    <div class="join">
      <h2>How do I join?</h2>
      <h2 class="h2-subtitle">Simply purchase a USB Club USB to <span class="mobile-hide"><br></span>receive an invite to the network.</h2>
      <button class="button purchase-button" @click="transitionTo('/classic')">
        <div class="purchase-button-inner">
          <span class="purchase-button-glowbe">
            <Glowbe :pulse="true" />
          </span>
          <div style="display: inline-block; margin-top: -2px;">Purchase a USB Club USB</div>
        </div>

        <span>Buy →</span>
      </button>
      <button class="button join-button" @click.prevent="toExternal('https://usbclub.typeform.com/to/aLLF8mwb')">
        <span class="join-button-inner">
          Already have one?
        </span>
        <span>Join →</span>
      </button>
    </div>

    <div class="spacer-medium"></div>

    <!-- Community Image Row -->
    <div class="full-width full-width--cutoff">
      <div class="carrying-images-container pre-show" ref="carryImages">
        <div class="carry edges">
          <div class="carry-space-sm"></div>
          <img src="/figures/carry/carry-1.png" />
          <img src="/figures/carry/carry-2.png" />
        </div>
        <div class="carry">
          <img src="/figures/carry/carry-3.png" />
          <img src="/figures/carry/carry-4.png" />
        </div>
        <div class="carry">
          <div class="carry-space-lg"></div>
          <img src="/figures/carry/carry-5.png" />
          <img src="/figures/carry/carry-6.png" />
        </div>
        <div class="carry">
          <img src="/figures/carry/carry-7.png" />
          <img src="/figures/carry/carry-8.png" />
        </div>
        <div class="carry">
          <div class="carry-space-lg"></div>
          <img src="/figures/carry/carry-9.png" />
          <img src="/figures/carry/carry-10.png" />
        </div>
        <div class="carry">
          <img src="/figures/carry/carry-11.png" />
          <img src="/figures/carry/carry-12b.png" />
        </div>
        <div class="carry edges">
          <div class="carry-space-md"></div>
          <img src="/figures/carry/carry-13.png" />
          <img src="/figures/carry/carry-14b.png" />
        </div>
      </div>
    </div>
    <div class="spacer-medium"></div>
    <div class="spacer-2 mobile-show"></div>

    <!-- Characters -->
    <div class="grid">
      <div class="column-full column-center">
        <h1>Meet the characters.</h1>
      </div>
    </div>

    <div class="spacer-5"></div>

    <div class="grid">
      <div class="column-four column-vertical-center mobile-show">
        <h2>USBs</h2>
        <p class="subtitle">Your USB Club key to unlock a<br />world of creative connections.</p>
      </div>
      <div class="column-four column-center">
        <!-- <img src="/figures/usb.png" /> -->
        <div class="character-usb character-usb__transport">
          <USBSceneTransport />
        </div>
        <div class="character-usb__glowbe-d">
          <Glowbe />
        </div>
        <div class="character-usb__glowbe-b">
          <Glowbe />
        </div>
        <div class="spotlight spotlight--usb">
          <img src="/figures/spotlight-usb.png" />
        </div>
      </div>
      <div class="column-four column-center">
        <!-- <img src="/figures/usb.png" /> -->
        <div class="character-usb">
          <USBScene />
        </div>
        <div class="character-usb__glowbe-a">
          <Glowbe />
        </div>
        <div class="character-usb__glowbe-c">
          <Glowbe />
        </div>
        <div class="spotlight spotlight--usb">
          <img src="/figures/spotlight-usb.png" />
        </div>
      </div>
      <div class="column-four column-vertical-center mobile-hide absolute-center-column">
        <h2>USBs</h2>
        <p class="subtitle">Your USB Club key to unlock a<br />world of creative connections.</p>
      </div>
    </div>

    <div class="spacer-5"></div>
    <div class="spacer-1 mobile-show"></div>

    <div class="grid">
      <div class="column-three mobile-show column-vertical-center">
        <h2>Desktop</h2>
        <p class="subtitle">Share files. Find friends. All from Desktop.</p>
      </div>
      <div class="column-five column-center">
        <img src="/figures/console-today.png" />
        <div class="character-console__glowbe-a">
          <Glowbe />
        </div>
        <div class="character-console__glowbe-b">
          <Glowbe />
        </div>
        <div class="spotlight spotlight--console">
          <img src="/figures/spotlight-console.png" />
        </div>
      </div>
      <div class="column-three column-vertical-center mobile-hide">
        <h2>Desktop</h2>
        <p class="subtitle">Share files. Find friends.<br />All from Desktop.</p>
        <h4 class="subtle">Via the <span><img src="/figures/icons/apple.svg" /></span> Mac Desktop App</h4>
      </div>
    </div>

    <div class="spacer-5"></div>
    <div class="spacer-1 mobile-show"></div>

    <div class="grid">
      <div class="column-four column-vertical-center mobile-show">
        <h2>Mobile</h2>
        <p class="subtitle">Get a pulse of the network.</p>
        <h4 class="subtle">Via the <span><img src="/figures/icons/apple.svg" /></span> iOS Mobile App</h4>
      </div>
      <div class="column-four column-center">
        <div class="companion-container">
          <img class="character-companion" src="/figures/usb-club-mobile.png" />
          <div class="character-companion__glowbe-a">
            <Glowbe />
          </div>
          <div class="character-companion__glowbe-b">
            <Glowbe />
          </div>
          <div class="character-companion__glowbe-c">
            <Glowbe />
          </div>
          <div class="spotlight spotlight--companion">
            <img src="/figures/spotlight-companion.png" />
          </div>
        </div>
      </div>
      <div class="column-four column-vertical-center mobile-hide">
        <h2>Mobile</h2>
        <p class="subtitle">Get a pulse of the network.</p>
        <h4 class="subtle">Via the <span><img src="/figures/icons/apple.svg" /></span> iOS Mobile App</h4>
      </div>
    </div>

    <div class="spacer-5"></div>

    <!-- <div class="grid">
      <div class="column-full column-console" @mousemove="handleMouseMove">
        <div class="console-content">
          <div class="console">
            <img src="/figures/console.png" />
            <div class="glowbe console-glowbe-1" :style="floatingStyle1" ref="glowbe1">
              <div class="glowbe-inner"></div>
              <div class="glowbe-outer"></div>
            </div>
            <div class="glowbe console-glowbe-2" :style="floatingStyle2">
              <div class="glowbe-inner"></div>
              <div class="glowbe-outer"></div>
            </div>
            <div class="glowbe console-glowbe-3" :style="floatingStyle3">
              <div class="glowbe-inner"></div>
              <div class="glowbe-outer"></div>
            </div>
          </div>
          <div class="companion">
            <img src="/figures/companion.png" />
            <p class="companion-label">Mobile App Included</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Footer -->
    <FooterBottom />
  </div>
</template>

<script>
import FooterBottom from "../FooterBottom.vue";
import JoinSteps from "../JoinSteps.vue";
import USBScene from "../USBScene.vue";
import USBSceneTransport from "../USBSceneTransport.vue";
// import LogoHero from "../LogoHero.vue";
import MediaCollage from "../MediaCollage.vue";
import Glowbe from "../Glowbe.vue";

export default {
  name: "Landing",
  components: {
    FooterBottom,
    // JoinSteps,
    USBScene,
    USBSceneTransport,
    // LogoHero,
    MediaCollage,
    Glowbe,
  },
  data() {
    return {
      chips: ['PDFs', 'OBJs', 'MOVs', 'JPGs', 'PSDs', 'CSVs', 'HTMLs', 'and More'],
      canPlayAudio: false,
      x1: 0,
      y1: 0,
      floatingStyle1: {},
      y2: 0,
      phaseOffset2: 0,
      floatingStyle2: {},
      y3: 0,
      phaseOffset3: 5,
      floatingStyle3: {},
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    },
  },
  created() {

  },
  mounted() {
    this.$refs.hero.classList.add('hero-show');
    this.$refs.mainCta.classList.add('hero-show');

    document.addEventListener('click', this.didUnlockAudio);

    this.animateFloat1();
    this.animateFloat2();
    this.animateFloat3();

    this.startEntrance();

    this.stickyListen();
  },
  methods: {
    stickyListen() {
      console.log('listening for .main-sticky stuck')
      const observer = new IntersectionObserver(
        ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
        { threshold: [1] }
      );

      observer.observe(document.querySelector('.main-sticky'));
    },
    startEntrance() {
      setTimeout(() => {
        // this.$refs.landingLogo.classList.add('step-1');

        // setTimeout(() => {
        // this.$refs.landingLogo.classList.remove('step-1');
        // this.$refs.landingLogo.classList.add('step-2');
        this.$refs.carryImages.classList.add('show');

        setTimeout(() => {
          // this.$refs.landingTitle.classList.add('show');
          // this.$refs.landingSubtitle.classList.add('show');
          // this.$refs.landingButton.classList.add('show');

          setTimeout(() => {


          }, 400);

        }, 300);
        // }, 0);

      }, 100);
    },
    didUnlockAudio() {
      this.canPlayAudio = true;
    },
    transitionTo(path) {
      this.$router.push(path);
      // set scroll of document to top 
      window.scrollTo(0, 0);
    },
    toExternal(url) {
      // go to external url 
      window.location.href = url;
    },
    animateFloat1(timestamp = 0) {
      // Calculate new y value based on a sine wave
      this.y1 = 15 * Math.sin(timestamp / 1200) + 20;
      // const floatY = 15 * Math.sin(timestamp / 1000) + 15;

      // Update CSS variable
      this.floatingStyle1 = { '--y': `${this.y1}px` };
      // this.floatingStyle1 = { 
      //   '--float-x': `${this.x1}px`,
      //   '--float-y': `${this.y1 + floatY}px`,
      // };

      // Schedule the next frame
      requestAnimationFrame(this.animateFloat1);
    },
    animateFloat2(timestamp = 0) {
      // Calculate new y value based on a sine wave
      this.y2 = 15 * Math.sin(timestamp / 950) + 15;

      // Update CSS variable
      this.floatingStyle2 = { '--y': `${this.y2}px` };

      // Schedule the next frame
      requestAnimationFrame(this.animateFloat2);
    },
    animateFloat3(timestamp = 0) {
      // Calculate new y value based on a sine wave
      this.y3 = 20 * Math.sin(timestamp / 800) + 15;

      // Update CSS variable
      this.floatingStyle3 = { '--y': `${this.y3}px` };

      // Schedule the next frame
      requestAnimationFrame(this.animateFloat3);
    },
    handleMouseMove(event) {
      // const rect = this.$refs.glowbe1.getBoundingClientRect();
      // const centerX = rect.left + rect.width / 2;
      // const centerY = rect.top + rect.height / 2;
      // const dx = centerX - event.clientX;
      // const dy = centerY - event.clientY;
      // const distance = Math.sqrt(dx * dx + dy * dy);

      // if (distance < 40) {
      //   const factor = Math.min(1, 1 - distance / 40);
      //   this.x1 = dx * factor;
      //   this.y1 = dy * factor;
      // } else {
      //   this.x1 = 0;
      //   this.y1 = 0;
      // }
    },
    hoverTransportBanner() {
      this.$refs.transportBannerArrow.classList.add("hovered")

    },
    unhoverTransportBanner() {
      this.$refs.transportBannerArrow.classList.remove("hovered")
    }
  },
};
</script>

<style scoped>
.grid {
  padding-left: 2rem;
  padding-right: 2rem;
}

.landing {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;
}

.mobile-show {
  display: none;
}


@media screen and (max-width: 700px) {
  .mobile-hide {
    display: none;
  }

  .mobile-show {
    display: initial;
  }

  .sticky.mobile-no-sticky {
    position: relative;
    top: initial;
  }
}

.globe-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

.globe-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.globe-background {
  position: absolute;
  width: 100%;
  z-index: 0;
  margin-top: calc((21rem / 2) + 0.5rem);
}

.globe-background img {
  width: 100%;
}

.usb {
  width: 21rem;
}

.usb img {
  width: 100%;
}

.carrying-images-container {
  width: 106vw;
  margin-left: -3vw;
}

.carrying-images-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 2rem;
}

.carrying-images-container.pre-show .carry:nth-child(1),
.carrying-images-container.pre-show .carry:nth-child(2),
.carrying-images-container.pre-show .carry:nth-child(3),
.carrying-images-container.pre-show .carry:nth-child(4),
.carrying-images-container.pre-show .carry:nth-child(5),
.carrying-images-container.pre-show .carry:nth-child(6),
.carrying-images-container.pre-show .carry:nth-child(7),
.carrying-images-container.pre-show .carry:nth-child(8) {
  opacity: 0;
  transform: translateY(120px);
  /* transition: all 300ms cubic-bezier(0.34, 0.13, 0.13, 1); */
  transition: all 500ms ease-in-out;
}

.carrying-images-container.pre-show .carry:nth-child(3),

.carrying-images-container.pre-show .carry:nth-child(5),


.carrying-images-container.pre-show .carry:nth-child(8),

.carrying-images-container.pre-show .carry:nth-child(1),

.carrying-images-container.pre-show .carry:nth-child(7) {
  transition: all 500ms cubic-bezier(0.42, 0, 0.37, 1.18)
}



.carrying-images-container.pre-show.show .carry:nth-child(1),
.carrying-images-container.pre-show.show .carry:nth-child(2),
.carrying-images-container.pre-show.show .carry:nth-child(3),
.carrying-images-container.pre-show.show .carry:nth-child(4),
.carrying-images-container.pre-show.show .carry:nth-child(5),
.carrying-images-container.pre-show.show .carry:nth-child(6),
.carrying-images-container.pre-show.show .carry:nth-child(7),
.carrying-images-container.pre-show.show .carry:nth-child(8) {
  opacity: 1;
  transform: translateY(0);
}

.carrying-images-container.pre-show.show .carry:nth-child(3) {
  transition-delay: 150ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(4) {
  transition-delay: 50ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(6) {
  transition-delay: 50ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(5) {
  transition-delay: 150ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(2) {
  transition-delay: 50ms;
}


.carrying-images-container.pre-show.show .carry:nth-child(8) {
  transition-delay: 150ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(1) {
  transition-delay: 150ms;
}

.carrying-images-container.pre-show.show .carry:nth-child(7) {
  transition-delay: 150ms;
}

.carry {
  display: flex;
  flex-direction: column;
  grid-gap: 2rem;
  min-height: 200px;
}

.carry img {
  border-radius: 1rem;
  width: 100%;
  height: auto;
}

.carry-space-sm {
  height: 3vw;
}

.carry-space-md {
  height: 4vw;
}

.carry-space-lg {
  height: 6vw;
}


@media screen and (max-width: 1100px) {
  .carrying-images-container {
    grid-template-columns: repeat(5, 1fr);
  }

  .carry.edges {
    display: none;
  }
}


@media screen and (max-width: 700px) {

  .carrying-images-container,
  .carry {
    grid-gap: 1.2rem;
  }

  .carry img {
    border-radius: 0.5rem;
  }

}

.landing-header {
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}



.landing-logo {
  display: flex;
  display: column;
  align-items: center;
  justify-content: center;
  height: 80px;
  min-height: 80px;
  position: relative;
}

.landing-logo img {
  position: absolute;
  height: 100%;
  width: auto;
}

.landing-logo .logo-blur-1 {
  opacity: 0;
  transition: all 300ms cubic-bezier(0.19, 0.47, 0.15, 1.01);
}

.landing-logo .logo-blur-2 {
  opacity: 0;
  transform: scale(0.6);
  transform-origin: center center;
  transition: all 300ms cubic-bezier(0.19, 0.47, 0.15, 1.01);
}

.landing-logo .logo-inside {
  opacity: 0;
  transform: scale(0.3);
  transition-delay: 0ms;
  transition: all 300ms cubic-bezier(0.19, 0.47, 0.15, 1.00);
  /* transition: all 300ms ease-in-out; */
}

.landing-logo .logo-outside {
  opacity: 0;
  transform: scale(0.75);
  /* transition: all 300ms cubic-bezier(0.19, 0.47, 0.15, 1.00); */
  transition: all 300ms ease-in-out;
}

/* .landing-logo.step-1 .logo-inside {
  opacity: 0.8;
  transform: scale(0.8);
  transition: all 750ms cubic-bezier(0.46, 0.06, 0.11, 1);
} */

.landing-logo.step-2 .logo-inside {
  opacity: 1;
  transform: scale(1);
}

.landing-logo.step-2 .logo-outside {
  opacity: 1;
  transform: scale(1);
  transition-delay: 50ms;
}

.landing-logo.step-2 .logo-blur-1 {
  opacity: 0.7;
  transform: scale(2);
  transition-delay: 250ms;
}

.landing-logo.step-2 .logo-blur-2 {
  opacity: 0.65;
  transform: scale(2);
  transition-delay: 250ms;
}


.landingTitle.pre-show,
.landingSubtitle.pre-show,
.landingButton.pre-show {
  opacity: 0;
  /* transform: translateY(-16px); */
  transition: all 300ms ease-in-out;
}

.landingTitle.pre-show.show,
.landingSubtitle.pre-show.show,
.landingButton.pre-show.show {
  opacity: 1;
  /* transform: translateY(0); */
}

.landingTitle.pre-show.show {
  transition-delay: 0ms;
}

.landingSubtitle.pre-show.show {
  transition-delay: 0ms;
}

.landingButton.pre-show.show {
  transition-delay: 50ms;
}


.landing-nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4rem;
  position: relative;
  z-index: 100;
}

.landing-nav__logo {
  margin-left: 3.2rem;
  align-self: flex-start;
  transition: all 150ms ease-in-out;
  z-index: 100;
}

.landing-nav__logo:hover {
  opacity: 0.75;
  cursor: pointer;
}

.landing-nav__logo:active {
  transform: scale(0.9);
}

.landing-nav__logo img {
  height: 2.4rem;
  width: auto;
}

@media screen and (max-width: 700px) {
  .landing-nav__logo {
    margin-left: 2.4rem;
    margin-top: 2.4rem;
  }

  .landing-nav__logo img {
    height: 2rem;
  }
}

.landing-nav-items {
  color: #DDEDFF;
  padding: 4rem;
  grid-gap: 20px;
  font-family: "ISO", monospace;
  font-size: 14px;
  letter-spacing: 0.2px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  width: 100%;
  position: absolute;
}

.landing-nav-items a,
.landing-nav-items a:visited {
  text-decoration: none;
  color: #DDEDFF;
  transition: all 350ms ease-in-out;
}

.landing-nav-items a:hover {
  color: white;
  text-decoration: none;
}

@media screen and (max-width: 600px) {

  .landing-nav {
    padding: 2.4rem;
  }

  .landing-nav-items {
    padding: 2.4rem;
    grid-gap: 20px;
  }

  .landing-logo {
    height: 4.2rem;
  }
}

.atm-collage,
.atm-collage img {
  width: 100%;
  height: auto;
}

.travels-container {
  width: 130%;
}

.travels {
  width: 100%;
  /* margin-left: -15%; */
  /* Gets centered by .column-md.center */
}

@media screen and (max-width: 700px) {

  .travels-container {
    width: 110%;
    /* height: 4rem; */
    box-sizing: border-box;
  }

  .travels-container svg {
    height: 100%;
  }
}

.partner {
  width: 400px;
  max-width: 80vw;
  align-self: center;
}

.partner .partner-icon {
  margin-bottom: 1.2rem;
}

.partner .partner-text {
  color: #D6D6D6;
  text-align: center;
  font-family: "Untitled Sans";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 1.2rem;
}

.partner .partner-label {
  color: #FFFFFF;
  text-align: center;
  font-family: "ISO";
  font-size: 1.8rem;
  font-style: italic;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 700px) {

  .partner-icon {
    height: 2.2rem;
  }

  .partner .partner-text {
    font-size: 1.6rem;
  }

  .partner .partner-label {
    font-size: 1.6rem;
  }
}




a.button.primary:visited {
  color: #ffffff;
}

.button.primary {
  --top-shadow-distance: 4px;
  color: #ffffff;
  /* color: #CFCFCF; */
  font-family: "Iosevka";
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 150%;
  padding-top: 0.8rem;
  padding-bottom: 0;
  padding-right: 2rem;
  padding-left: 2rem;
  text-align: center;
  width: 100%;
  /* background: #2D2D2D; */
  /* border: 1px solid #131313; */
  border: none;
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.35),
    inset 0px
      var(--top-shadow-distance) 7px #484848,
        inset 0px -4px 5.91837px rgba(0, 0, 0, 0.35);
  border-radius: 8px; */

  box-sizing: border-box;
  -webkit-appearance: none;
  transition: all 150ms ease-in-out;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  user-select: none;
  text-decoration: none;
  width: fit-content;
  height: 4.6rem;
  display: inline-block;
  text-shadow: 0px 1.3px 2px rgba(0, 0, 0, 0.5);

  border-radius: 0.6rem;
  /* border-radius: 100px; */
  background: #249EF6;
  box-shadow: 0px 2.47089px 2.47089px 0px #4CD7F6 inset, 0px 9.88355px 9.88355px 0px rgba(0, 0, 0, 0.3), 0px -2.47089px 4.94177px 0px #114D6F inset;
}


a.button.primary:hover {
  color: #ffffff;

  background: #2092E4;
}

.button.primary:hover {
  cursor: pointer;
  background: #2092E4;
  /* box-shadow: 0px 7px 9px rgba(0, 0, 0, 0.55),
    inset 0px
      var(--top-shadow-distance) 7px #484848,
        inset 0px -4px 5.91837px rgba(0, 0, 0, 0.35); */

  box-shadow: 0px 2.47089px 2.47089px 0px #4CD7F6 inset, 0px 9.88355px 9.88355px 0px rgba(0, 0, 0, 0.25), 0px -2.47089px 4.94177px 0px #114D6F inset;
  color: #ffffff;
  background:
    /* border: 1px solid #AEAEAE; */
}

.button.primary:active {
  color: #ffffff;
  /* box-shadow: 0px 0px 0px rgba(0, 0, 0, 0),
    inset 0px calc(var(--top-shadow-distance) - 9px) 5px rgba(72, 72, 72, 0.6),
    inset 0px 7px 5.91837px rgba(0, 0, 0, 0.36); */

  box-shadow: 0px -2.53px 3px 0px #4CD7F6 inset, 0px 1.88px 3.88px 0px rgba(0, 0, 0, 0.25), 0px 2.53px 4.94177px 0px #0d3d58 inset;
  /* box-shadow: 0px 0px 0px rgba(0, 0, 0, 0),
    inset 0px -2px 5px rgba(72, 72, 72, 0.6),
    inset 0px 7px 5.91837px rgba(0, 0, 0, 0.36); */
}


@media screen and (max-width: 700px) {
  .button.primary {
    font-size: 1.6rem;
    padding-bottom: 1rem;
  }

}



.console-content {
  width: 100%;
  position: relative;
}

.console {
  width: 100%;
  position: relative;
  z-index: 0;
}

.console img,
.companion img {
  width: 100%;
}

.companion {
  width: 440px;
  position: absolute;
  z-index: 10;
  right: 0;
  margin-right: 10rem;
  display: flex;
  bottom: 0;
  align-items: center;
  flex-direction: column;
}

.companion-label {
  margin-top: -3rem;
  text-align: center;
  font-size: 2rem;
  color: #B3B3B3;
}

@media screen and (max-width: 1240px) {
  .companion {
    margin-right: 5.6rem;
    width: 30vw;
    min-width: 136px;
    bottom: -4rem;
  }

  .companion-label {
    margin-top: 0;
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 700px) {
  .companion {
    margin-right: 4rem;
  }
}



/* .glowbe {
  --x: 0px;
  --y: 0px;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  transition: all 50ms cubic-bezier(0.18, 0.3, 0.39, 0.5);
  transform: translate(var(--x), var(--y));
}

.glowbe-inner {
  position: absolute;
  background-color: white;
  filter: blur(6px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.glowbe-outer {
  position: absolute;
  background: #2097ED;
  filter: blur(20px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
  opacity: 0.6;
} */

.console-glowbe-1 {
  position: absolute;
  left: -27px;
  top: 180px;
}

.console-glowbe-2 {
  position: absolute;
  left: 155px;
  bottom: -30px;
  height: 2.7rem;
  width: 2.7rem;
  opacity: 0.9;
}

.console-glowbe-2 .glowbe-outer {
  filter: blur(15px);
}

.console-glowbe-3 {
  position: absolute;
  bottom: 213px;
  right: -36px;
  height: 2.2rem;
  width: 2.2rem;
  opacity: 0.9;
}

.console-glowbe-3 .glowbe-outer {
  filter: blur(15px);
}

@media screen and (max-width: 700px) {
  .console-glowbe-1 {
    left: -7px;
    top: 43px;
    height: 2rem;
    width: 2rem;
  }

  .console-glowbe-1 .glowbe-outer {
    filter: blur(15px);
  }

  .console-glowbe-2 {
    left: 57px;
    bottom: -20px;
    opacity: 0.8
  }

  .console-glowbe-3 {
    bottom: 76px;
    right: -10px;
    height: 1.8rem;
    width: 1.8rem;
    opacity: 0.8;
  }

}

.sound-label {
  font-family: 'ISO';
  font-size: 1.6rem;
  line-height: 150%;
  color: #bebebe;
}

.landing.fade-enter-from {
  opacity: 1;
  transform: translate(0)
}


.landing-desktop-show {
  display: inline;
}

@media screen and (max-width: 1600px) {
  .column-console {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .companion {
    width: 380px;
  }
}

@media screen and (max-width: 700px) {
  .landing-desktop-show {
    display: none;
  }

  .column-console {
    padding-left: 0;
    padding-right: 0;
  }
}

@media screen and (max-width: 1200px) {

  .companion {
    width: 25vw;
  }
}

.filetypes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  grid-gap: 1rem;
}

.chip {
  padding: 0.8rem 0.8rem 0.6rem 0.8rem;
  font-family: "ISO", monospace;
  font-size: 2rem;
  color: #D6D6D6;
  background: #303030;
  border-radius: 4px;
}

@media screen and (max-width: 775px) {
  .filetypes {
    grid-gap: 0.8rem;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }

  .chip {
    padding: 0.6rem 0.6rem 0.4rem 0.6rem;
    font-size: 1.4rem;
  }
}

.cta {
  font-family: "ISO", monospace;
  font-size: 1.6rem;
  background: #343434;
  color: rgba(255, 255, 255, 0.85);
  padding: 1.3rem 1.7rem 1.1rem 1.7rem;
  box-shadow: inset 0 3px 6px 0px rgba(255, 255, 255, 0.25), 0px 3px 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 200px;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  text-decoration: none;
  transition: all 175ms ease-in-out;
  transform-origin: center center;
}

.cta .cta-arrow {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-left: 0.8rem;
  opacity: 0.85;
  transition: all 175ms ease-in-out;
}

.cta .cta-arrow .lightup {
  position: absolute;
  transition: all 175ms ease-in-out;
}

.cta:hover {
  box-shadow: inset 0 3px 6px 0px rgba(255, 255, 255, 0.35), 0px 3px 6px 0 rgba(0, 0, 0, 0.15);
  color: #ffffff;
  text-shadow: rgba(255, 255, 255, 0.5) 0px 0 5px, rgba(255, 255, 255, 0.55) 0px 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.cta:hover .cta-arrow {
  opacity: 1;
  transform: translateX(0.2rem);
}

.cta:hover .cta-arrow .lightup {
  filter: blur(3px);
}

@media screen and (max-width: 700px) {
  .cta {
    font-size: 1.4rem;
    padding: 1.1rem 1.4rem 0.8rem 1.4rem;
  }
}

/* Sticky */
.sticky {
  position: sticky;
  top: 3.2rem;
  z-index: 1000;
}

.main-sticky.sticky {
  top: -2px;
  padding-top: 3.85rem;
  transition: all 75ms ease-in-out;
  transform-origin: center center;
}

.main-sticky.sticky[stuck] .cta {
  box-shadow: inset 0 3px 6px 0px rgba(255, 255, 255, 0.25), 0px 6px 20px 0 rgba(0, 0, 0, 1);
}

.main-sticky.sticky:active {
  transform: scale(0.95);
}


/* 

Characters 

*/

.character-usb {
  position: relative;
  /* display: flex; */
  width: 100%;
  /* height: 400px; */
  animation: float 5s ease-in-out infinite;
  z-index: 10;
}

.character-usb__transport {
  width: 300px;
  max-width: 100%;
}

/*  USB glowbes */

.character-usb__glowbe-a,
.character-usb__glowbe-b,
.character-usb__glowbe-c,
.character-usb__glowbe-d {
  animation: floatAndPulse 6s ease-in-out infinite;
}

.character-usb__glowbe-d {
  top: -65%;
  left: -23%;
  position: relative;
  opacity: 0.8;
  transform: scale(0.8);
}

.character-usb__glowbe-a {
  top: -70%;
  right: -23%;
  position: relative;
}

.character-usb__glowbe-b {
  animation-delay: 1s;
  position: relative;
  top: -28%;
  left: -19%;
}

.character-usb__glowbe-c {
  animation-delay: 1s;
  position: relative;
  top: -25%;
  right: -15%;
}

.character-usb__glowbe-b .glowbe {
  opacity: 0.75;
  transform: scale(0.75);
}

.character-usb__glowbe-c .glowbe {
  opacity: 0.5;
  transform: scale(0.6);
}

/*  Console glowbes */
.character-console__glowbe-a,
.character-console__glowbe-b {
  animation: floatAndPulse 6s ease-in-out infinite;
}

.character-console__glowbe-a .glowbe {
  transform: scale(1.2);
}

.character-console__glowbe-b .glowbe {
  opacity: 0.8;
  transform: scale(0.65);
}

.character-console__glowbe-a {
  top: -31%;
  left: -44%;
  position: relative;
  z-index: -1;
}

.character-console__glowbe-b {
  animation-delay: 1s;
  position: relative;
  top: -16%;
  right: -38%;
}

/*  Companion glowbes */
.character-companion__glowbe-a,
.character-companion__glowbe-b,
.character-companion__glowbe-c {
  animation: floatAndPulse 6s ease-in-out infinite;
}

.character-companion__glowbe-a .glowbe {
  opacity: 0.7;
  transform: scale(0.5);
}

.character-companion__glowbe-b .glowbe {
  opacity: 0.8;
  transform: scale(0.85);
}

.character-companion__glowbe-b .glowbe {
  transform: scale(0.8);
}

.character-companion__glowbe-a {
  top: -72%;
  left: -22%;
  position: relative;
  z-index: -1;
}

.character-companion__glowbe-b {
  animation-delay: 1s;
  position: relative;
  top: -36%;
  left: -15%;
}

.character-companion__glowbe-c {
  animation-delay: 1.5s;
  position: relative;
  top: -70%;
  right: -22%;
}

.character-companion {
  position: relative;
  max-width: 255px;
  animation: float 5s ease-in-out infinite;
  z-index: 10;
}

.companion-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(5vw);
}


@keyframes float {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-6px);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes floatAndPulse {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  50% {
    transform: translateY(-12px);
    opacity: 0.6;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.spotlight.spotlight--usb {
  width: 60%;
  animation: shrink 5s ease-in-out infinite;
  transform-origin: center center;
  margin-top: -6rem;
  z-index: 0;
}

.spotlight.spotlight--console {
  width: 80%;
  animation: shrink 5s ease-in-out infinite;
  transform-origin: center center;
  margin-top: -7rem;
  z-index: -1;
}

.spotlight.spotlight--companion {
  width: 50%;
  animation: shrink 5s ease-in-out infinite;
  transform-origin: center center;
  margin-top: -12rem;
  z-index: -1;
}

@keyframes shrink {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}

.transport-banner {
  margin-bottom: 2.25vw;
  position: relative;
  height: 27.5vw;
  width: 100%;
  cursor: pointer;
}

.transport-banner-inner {
  border-radius: 6vw;
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
    border-radius: 6vw;

    object-position: center;
    object-fit: cover;

  }

  h2.h2-subtitle {
    font-family: "Untitled Serif", serif;
    font-size: 32px;
    letter-spacing: -1px;
  }
}

.transport-banner-shadow {
  position: absolute;
  border-radius: 6vw;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 -0.25vw 1vw 0 rgba(255, 255, 255, 0.75), inset 0 0.25vw 1vw 0 rgba(0, 0, 0, 0.75);
}

.transport-banner-text-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 5rem;
  left: 5rem;

  h1 {
    font-family: "Untitled Sans", sans-serif;
    font-size: 42px;
    letter-spacing: -1px;
  }

  h3 {
    font-family: "ISO", monospace;
    font-size: 20px;
  }

  .arrow-right {
    img {
      width: unset;
      position: relative;
      transform: scale(1.4) translate(1px, -1px);
      object-fit: unset;
      object-position: unset;
      transition: all 0.25s ease-in-out;
    }

    &.hovered {
      img {
        transition: all 0.25s ease-in-out;
        transform: scale(1.4) translate(5px, -1px);

      }
    }
  }

}

@media screen and (max-width: 775px) {
  .transport-banner {
    height: 32rem;
    margin-bottom: 2.6vw;

    .transport-banner-inner img {
      object-position: 40% top;
    }
  }
  .transport-banner-text-container {
    top: unset;
    bottom: 2.5rem;
    left: 2.5rem;

    h1, h2, h3 {
      margin-bottom: 0;
    }

    h3 {
      font-size: 16px;
    }

    h1 {
      font-size: 40px;
    }

    h2.h2-subtitle {
      font-size: 20px;
      margin-top: 2px;
    }

    h2.h2-subtitle span.arrow-right img {
      transform: none;
      margin-left: 2px;
      width: 14px;
    }
  }
}



.folder-top {
  display: flex;
  width: 100%;
}

.folder-bottom {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.folder-bottom__bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-image: url('/figures/folder-bottom.png');
  background-size: 100% 100%;
}

/* .folder-bottom__bg img {
  width: 100%;
  height: auto;
  object-fit: cover;
} */

.join {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
  box-sizing: border-box;

  .button {
    border-radius: 9999px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      span {
        transform: scale(0.9);
      }
    }
  }

  .purchase-button {
    height: 8rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding-left: 3rem;
    padding-right: 2rem;

    .purchase-button-inner {
      font-family: "Untitled Serif", serif;
      display: flex;
      gap: 1.5rem;
      font-size: 26px;
      letter-spacing: -1px;
    }
  }

  .join-button {
    width: 32rem;
    padding-top: 1rem;

    .join-button-inner {
      font-family: "Untitled Serif", serif;
      font-size: 20px;
      letter-spacing: -0.5px;
    }
  }
}

@media screen and (max-width: 775px) {
  .join {
    width: 100%;
    padding: 2rem 4rem 4rem 4rem;
    h2 {
      font-size: 24px;
    }
    h2.h2-subtitle {
      font-size: 23px;
    }
    .purchase-button {
      padding-left: 2.5rem;

      .purchase-button-inner {
        font-size: 17px;
      }
    }

    .join-button {
      width: 26rem;
    }

  }
}

@media screen and (max-width: 775px) {
  .folder-bottom {
    padding-left: 1.8rem;
    padding-right: 1.8rem;
    box-sizing: border-box;
  }

  .spotlight.spotlight--console {
    margin-top: -5rem;
  }

  .spotlight.spotlight--usb {
    margin-top: -11rem;
  }

  .spotlight.spotlight--companion {
    margin-top: -13rem;
  }

  .character-usb__glowbe-b {
    top: -47%;
    left: initial;
    right: -20%;
  }

  .character-usb__glowbe-c {
    top: -42%;
    right: 0;
    left: -16%;
  }


  .character-console__glowbe-b {
    top: -22%;
  }


  .character-companion__glowbe-a {
    top: -72%;
    left: -36%;
  }

  .character-companion__glowbe-b {
    top: -36%;
    left: -24%;
  }

  .character-companion__glowbe-c {
    top: -72%;
    right: -33%;
  }

  .companion-container {
    transform: translateX(0);
  }
}


.hero-hide-1,
.hero-hide-2,
.hero-hide-3,
.hero-hide-4 {
  opacity: 0;
  transition: all 400ms ease-in-out;
  transform: translateY(-8px);
  filter: blur(3px);
}

.hero-show .hero-hide-1 {
  opacity: 1;
  transition-delay: 0ms;
  transform: translateY(0);
  filter: blur(0px);
}

.hero-show .hero-hide-2 {
  opacity: 1;
  transition-delay: 150ms;
  transform: translateY(0);
  filter: blur(0px);
}

.hero-show .hero-hide-3 {
  opacity: 1;
  transition-delay: 200ms;
  transform: translateY(0);
  filter: blur(0px);
}

.hero-show .hero-hide-4 {
  opacity: 1;
  transition-delay: 350ms;
  transform: translateY(0);
  filter: blur(0px);
}

.logo-video {
  position: relative;
  width: 82%;
  max-width: 1360px;
  padding-top: 0;
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  /* mix-blend-mode: screen; */
  /* opacity: 0; */

  /* transition: opacity 3s ease-in-out; */
  /* transition-delay: 1s; */
}

.logo-video.hero-show {
  /* opacity: 1; */
}

@media screen and (max-width: 775px) {
  .logo-video {
    width: 100%;
    padding-top: 17rem;
    padding-bottom: 4rem;
  }
}
</style>
